export default {
	name: 'task_0_2',
	description: 'Заставка',
	title: 'Выбор сложности',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите сложность вопросов",
			options: [
                'Низкая: я ещё новичок в этой области',
                'Высокая: я чувствую уверенность в своих знаниях',
			],
			correct: [0]
        };
	},
	isCompleted: () => true,
};